import { render } from "./Representantes.vue?vue&type=template&id=2913e11a"
import script from "./Representantes.vue?vue&type=script&lang=js"
export * from "./Representantes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__